import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService, CustomQueryEncoderHelper } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { LogService } from '../../Core/Abstract/log.service';

import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';
import { Register } from './Register';

@Injectable()

export class RegisterService extends SecurityService {

    constructor(http: HttpClient, configService: ConfigService, eventsEmitterService: EventsEmitterService, router: Router, logger: LogService) {
        super(http, configService, eventsEmitterService, router, logger);
    }

    getRules(): Observable<any> {
        let serviceUrl = this.baseUrl + 'LoginService/rules';
        return this.http.get(serviceUrl).pipe(map(super.extractData),catchError(super.handleError));
    }

    public getCountryList(langId: string): Observable<any> {
        let serviceUrl = 
        this.baseUrl + "UtilService/getCountryList?langId=" + langId;
       
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    public getCountryCodesList(langId: string): Observable<any> {
    let serviceUrl = 
    this.baseUrl + "UtilService/getCountryMobileCodes?langId=" + langId;
    
    return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
}


    public registerRequest(register: Register){

        let serviceUrl = this.baseUrl + 'RegistrationService/registrationCaptcha?token=' + register.token;
        let headers = new HttpHeaders({
            //'Authorization':'Basic YW5ndWxhcjItY2xpZW50OmFuZ3VsYXIy',
            'Content-Type': 'application/json; charset=utf-8'
        });
        let options = ({ headers: headers });

        //username == mail
        register.username = register.email;

        return this.http.post(serviceUrl, register, options).pipe(map(super.extractData),catchError(super.handleError));
    }

    public confirmRequest(token){

        let serviceUrl = this.baseUrl + 'RegistrationService/confirm';
     

        return this.http.get(serviceUrl,  { responseType: 'text', params: {'token': token}}).pipe(catchError(super.handleError));
        // return this.http.post(serviceUrl, token, options).pipe(map(super.extractData),catchError(super.handleError));
    }

    public resendTokenRequest(token,mail){

        let serviceUrl = this.baseUrl + 'RegistrationService/resendRegistrationToken';
        let headers = new HttpHeaders({
            //'Authorization':'Basic YW5ndWxhcjItY2xpZW50OmFuZ3VsYXIy',
            'Content-Type': 'application/json; charset=utf-8'
        });
        let options = ({ headers: headers,params: { 'token':token, 'mail':mail } });

        return this.http.get(serviceUrl, options);
        // return this.http.post(serviceUrl, { 'token':token, 'mail':mail }, options).pipe(map(super.extractData),catchError(super.handleError));
    }
    
    public validateToken(token){
        let headers = new HttpHeaders({
        });

        let serviceUrl = this.baseUrl + 'RegistrationService/validate?token='+token;

        return this.http.get(serviceUrl,  { responseType: 'text',headers: headers}).pipe(catchError(super.handleError));
    }
    checkCountryBytoken(token){
        let headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
        let options = ({ headers: headers});
        let serviceUrl = this.baseUrl + 'RegistrationService/getCountryByToken?token='+token;
        return this.http.get(serviceUrl, options).pipe(map(super.extractData),catchError(super.handleError));
    }
    public getTermsByToken(token){
        let headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        });
        let options = ({ headers: headers});

        let serviceUrl = this.baseUrl + 'RegistrationService/getTermsByToken?token='+token;

        return this.http.get(serviceUrl, options).pipe(map(super.extractData),catchError(super.handleError));
    }
    getIsMiddle(userId){
        let serviceUrl = this.baseUrl + 'UtilService/getIsMiddleUserStatus?userId='+userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
    public rejectBySupplier(token){
        let headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        });
        let options = ({ headers: headers});

        let serviceUrl = this.baseUrl + 'RegistrationService/reject?token='+token;

        return this.http.get(serviceUrl, options).pipe(map(super.extractData),catchError(super.handleError));
    }

    public generateOtp(form, token){
        let headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        });
        let options = ({ headers: headers});

        let serviceUrl = this.baseUrl + 'RegistrationService/generateOtp?token='+token;

        return this.http.post(serviceUrl,form, options).pipe(map(super.extractData),catchError(super.handleError));
    }

    public submitClientForm(form,token){
        let headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        });
        let options = ({ headers: headers});

        let serviceUrl = this.baseUrl + 'RegistrationService/submitClientForm?token='+token;

        return this.http.post(serviceUrl,form, options).pipe(map(super.extractData),catchError(super.handleError));
    }

    public getDocTerms(lang){
        let headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        });
        let options = ({ headers: headers});

        let serviceUrl = this.baseUrl + 'RegistrationService/getClientBankConditions?langId='+lang;

        return this.http.get(serviceUrl, options).pipe(map(super.extractData),catchError(super.handleError));
    }

}